// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import css from './PcFullColumn.scss'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  image: ?{
    url: string
  },
  children: React.ChildrenArray<React.Node>,
  onClick: () => void,
  isShow?: boolean
};

@computeData()
export default class PcFullColumn extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      type: 'image',
      title: '通栏图片'
    }
  ];

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, children, image } = this.props
    let { style } = this.props

    if (image) {
      style = Object.assign(
        {
          background: `url(${image.url}) center center no-repeat`
        },
        style
      )
    }

    return (
      <div style={style} id={id}>
        <div className={css.main}>{children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/pc/PcFullColumn.js